<template>
  <exportTemplate ref="exportTemplate" :showExport="false" :showCustomColumns="false" placement="top" :formModel="formModel" :table-data="tableList" :table-total="paginationTotal" :table-load="tableLoading" @pagination-change="paginationChange" @form-submit="formSubmit" @form-reset="formReset" @sort="sortChange" @row-dblclick="rowDblclick" @selection-change="handleSelectionChange">
    <template #form>
      <el-form-item label="用户名" prop="accountName">
        <el-input placeholder="请输入用户名查询" v-model="formModel.accountName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="formSubmit">查询</el-button>
        <el-button size="small" @click="formReset">重置</el-button>
        <el-button type="success" @click="dialogShow('add')">新增</el-button>
        <el-button type="primary" @click="toShowParentId">批量修改渠道经理</el-button>
      </el-form-item>
    </template>
    <template #formFooter>
      <span></span>
    </template>
    <template>
      <el-table-column type="selection" fixed width="50" reserve-selection :selectable="selectable"></el-table-column>
      <el-table-column label="用户名称" prop="accountName" width="170" fixed></el-table-column>
      <el-table-column label="用户类型" prop="personnelType" width="100">
        <template #default="{ row }">
          <span v-if="row.personnelType == '1'">渠道</span>
          <!-- <span v-else-if="row.personnelType == '2'">渠道业务</span> -->
          <span v-else-if="row.personnelType == '3'">渠道经理</span>
          <span v-else-if="row.personnelType == '4'">大区经理</span>
          <span v-else>{{row.personnelType}}</span>
        </template>
      </el-table-column>
      <el-table-column label="是否可用" prop="isEnabled" width="80">
        <template #default="{ row }">
          <span v-if="row.isEnabled == 'Y'">可用</span>
          <span v-else-if="row.isEnabled == 'N'">不可用</span>
          <span v-else>{{row.isEnabled}}</span>
        </template>
      </el-table-column>
      <el-table-column label="负责人" prop="fzrName" width="170"></el-table-column>
      <el-table-column label="负责人电话" prop="phone" width="170"></el-table-column>
      <el-table-column label="注册日期" prop="entryDate" width="100"></el-table-column>
      <el-table-column label="注册时间" prop="entryTime" width="100"></el-table-column>
      <el-table-column label="相关操作" prop="monthQty" width="170">
        <template #default="{ row }">
          <!-- <el-button type="danger" @click="resetPassword(row)" size="mini">重置密码</el-button> -->
          <el-button type="primary" @click="dialogShow('edit', row)" size="mini">修改</el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog
        :title="dialogState == 'add' ? '新增用户' : '编辑用户'"
        :visible.sync="dialogVisible"
        @closed="dialogClose"
        v-if="dialogVisible"
        append-to-body :close-on-click-modal="false"
        width="650px">
      <template>
        <el-form class="dialogForm" :key="dialogState" ref="dialogForm" :rules="dialogForm.personnelType == 4 ? (dialogState == 'add' ? dialogFormRules : {...dialogFormRules, ...editFormRules}) : (dialogState == 'add' ? { ...dialogFormRules, ...fzrNameFormRules } : {...dialogFormRules, ...editFormRules, ...fzrNameFormRules})" :model="dialogForm" label-width="100px">
          <el-form-item label="账号" prop="accountName">
            <el-input v-model="dialogForm.accountName" autocomplete="off" auto-complete="new-password" placeholder="请输入用户名称"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="passWord">
            <el-input style="width: 202px;" autocomplete="off" v-model="dialogForm.passWord" auto-complete="new-password" show-password placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="用户类型" prop="personnelType">
            <el-select style="width: 202px;" v-model="dialogForm.personnelType" placeholder="请选择用户类型" @change="personnelTypeChange">
              <el-option label="渠道" value="1"></el-option>
              <!-- <el-option label="渠道业务" value="2"></el-option> -->
              <el-option label="渠道经理" value="3"></el-option>
              <el-option label="大区经理" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="负责人名称" prop="fzrName">
            <el-input v-model="dialogForm.fzrName" placeholder="请输入负责人名称"></el-input>
          </el-form-item>
          <el-form-item v-if="dialogForm.personnelType == 1 || dialogForm.personnelType == 3" :label="dialogForm.personnelType == 1 ? '渠道经理' : '大区经理'" prop="parentId">
            <select-multiple ref="fzrRefs" style="width: 202px;" :select-data="fzrName" :change="fzrChange"></select-multiple>
          </el-form-item>
          <el-form-item label="负责人电话" prop="phone">
            <el-input v-model.number="dialogForm.phone" placeholder="请输入负责人电话"></el-input>
          </el-form-item>
          <el-form-item label="是否可用" prop="isEnabled">
            <el-switch v-model="dialogForm.isEnabled" active-value="Y" inactive-value="N"></el-switch>
          </el-form-item>
          <el-form-item label="地址" prop="provinceName" style="width: 100%;">
            <el-input v-model="dialogForm.provinceName" type="textarea" placeholder="请输入地址"></el-input>
          </el-form-item>
          <div style="width: 100%; text-align: center;">
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button @click="dialogClose">取消</el-button>
          </div>
        </el-form>
      </template>
    </el-dialog>
    <el-dialog
        title="修改渠道经理"
        :visible.sync="dialogChannelVisible"
        v-if="dialogChannelVisible"
        @closed="dialogChannelClose"
        append-to-body :close-on-click-modal="false"
        width="450px">
      <template>
        <el-form class="dialogForm" ref="dialogChannelForm" :rules="parentIdFormRules" :model="channelForm" label-width="100px">
          <el-form-item label="渠道经理" prop="id">
            <select-multiple style="width: 202px;" :select-data="parentId" :change="parentIdChange"></select-multiple>
          </el-form-item>
          <div style="width: 100%; text-align: center;">
            <el-button type="primary" @click="onChannelSubmit">提交</el-button>
            <el-button @click="dialogChannelClose">取消</el-button>
          </div>
        </el-form>
      </template>
    </el-dialog>
  </exportTemplate>
  
</template>

<script>
import exportTemplate from '@/components/common/exportTemplate.vue'
export default {
  name: 'mainAccount',
  components: {
    exportTemplate
  },
  data() {
    return {
      params: {
        accountName: '',
        page: 1,
        size: 20
      },
      formModel: {
        accountName: ''
      },
      paginationTotal: 0,
      tableList: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: {
        accountName: '',
        passWord: '',
        fzrName: '',
        phone: '',
        provinceName: '',
        personnelType: '1',
        isEnabled: 'Y',
        parentId: ''
      },
      dialogFormRules: {
        'accountName': [
          { required: true, message: '请输入用户名称', trigger: 'blur' }
        ],
        'passWord': [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        'personnelType': [
          { required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        'phone': [
          { required: true, message: '请输入负责人电话', trigger: 'blur' }
        ]
      },
      fzrNameFormRules: {
        'parentId': [
          { required: true, message: '请选择', trigger: 'change' }
        ],
      },
      editFormRules: {
        'passWord': [
          { required: false }
        ],
      },
      fzrName: { submitName: 'fzrName', selected: '', valueIsObj: false, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isScroll: false, isPagination: false, isReSearch: false, list: [], placeholder: '请选择渠道经理', request: { url: '/Account/monitorCenterChannelInfo/selectCrmUserList.html', type: 'post', params: { isPersonnelType: 0 }, text: '', value: '' }},
      dialogState: 'add',
      multipleSelection: [],
      dialogChannelVisible: false,
      parentIdFormRules: {
        'parentId': [
          { required: true, message: '请选择渠道经理', trigger: 'change' }
        ],
      },
      parentId: { submitName: 'parentId', selected: '', valueIsObj: false, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isScroll: false, isPagination: false, isReSearch: false, list: [], placeholder: '请选择渠道经理', request: { url: '/Account/monitorCenterChannelInfo/selectCrmUserList.html', type: 'post', params: { isPersonnelType: 0 }, text: '', value: '' }},
      channelForm: {
        id: '',
        ids: []
      }
    }
  },
  created() {
    this.getTableList()
  },
  methods: {
    paginationChange({page, size, isGetTable = true}) {
      this.params.page = page
      this.params.size = size
      if (isGetTable) {
        this.getTableList()
      }
    },
    formSubmit() {
      this.params = { ...this.params, ...this.formModel }
      this.getTableList()
    },
    formReset() {
      let exportTemplate = this.$refs.exportTemplate
      exportTemplate.$refs.queryFormRef.resetFields()
      exportTemplate.$refs.table.clearSort()
      this.params['sortField'] = ''
      this.params['softBy'] = ''
      this.params.page = 1
    },
    async getTableList() {
      this.tableLoading = true
      this.tableData = []
      const { data: res } = await this.$http.post(
        "/Account/monitorCenterChannelInfo/selectUsers.html",
        this.Qs.stringify(this.params)
      )
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      let { rows, total } = JSON.parse(res.result)
      this.paginationTotal = total
      this.tableList = rows
    },
    sortChange({ sortField, sortBy }) {
      this.params['sortField'] = sortField
      this.params['sortBy'] = sortBy
      this.params.page = 1
      this.getTableList()
    },
    rowDblclick({ row }) {
      console.log(row);
    },
    resetPassword(row) {
      console.log(row);
    },
    dialogClose() {
      this.$refs.dialogForm.resetFields()
      this.$refs.dialogForm.clearValidate()
      this.dialogVisible = false
    },
    dialogShow(tag, row = {}) {
      this.dialogState = tag
      this.dialogVisible = true
      if (tag == 'edit') {
        this.dialogForm = {...row}
        console.log(row)
        if(row.personnelType == 1) {
          this.fzrName.placeholder = '请选择渠道经理'
          this.fzrName.request.params.isPersonnelType = 0
        } else if(row.personnelType == 3) {
          this.fzrName.placeholder = '请选择大区经理'
          this.fzrName.request.params.isPersonnelType = 1
        }
        if(row.parentId) {
          this.fzrName.selected = row.parentId
        }
      } else {
        this.dialogForm = {
          accountName: '',
          passWord: '',
          fzrName: '',
          phone: '',
          provinceName: '',
          personnelType: '1',
          isEnabled: 'Y',
          parentId: ''
        }
        this.fzrName.selected = ''
      }
      if(this.$refs.fzrRefs){
        this.$refs.fzrRefs.getList()
      }    
    },
    personnelTypeChange(val) {
      this.dialogForm.fzrName = ''
      this.dialogForm.parentId = ''
      this.fzrName.selected = ''
      if(val == 1) {
        this.fzrName.placeholder = '请选择渠道经理'
        this.fzrName.request.params.isPersonnelType = 0
      } else if(val == 3) {
        this.fzrName.placeholder = '请选择大区经理'
        this.fzrName.request.params.isPersonnelType = 1
      } else if (val == 2) {
        console.log(1);
      }
    },
    fzrChange(row) {
      // this.dialogForm.fzrName = row.text
      this.dialogForm.parentId = row
      console.log(row);
    },
    selectable(row) {
      if (row.personnelType == '1') {
        return true
      } else {
        return false
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    toShowParentId() {
      if(this.multipleSelection.length == 0) return this.$message.error("请先选择用户")
      this.dialogChannelVisible = true
    },
    parentIdChange(row) {
      this.channelForm.id = row
      console.log(row);
    },
    dialogChannelClose() {
      this.dialogChannelVisible = false
      this.$refs.dialogChannelForm.resetFields()
    },
    onChannelSubmit() {
      console.log(this.multipleSelection)
      let arr = []
      this.multipleSelection.forEach(it => {
        arr.push(it.id)
      })
      this.channelForm.ids = arr.join(',')
      let url = '/Account/monitorCenterChannelInfo/updateBatchParentId.html'
      this.$refs.dialogChannelForm.validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            url,
            this.Qs.stringify(this.channelForm)
          )
          if (res.code != 'success') return this.$message.error(res.message)
          this.$message.success(res.message)
          this.dialogChannelClose()
          this.getTableList()
          let exportTemplate = this.$refs.exportTemplate
          exportTemplate.$refs.table.clearSelection()
          this.multipleSelection = []
          this.parentId.selected = ''
          console.log(res);
        }
      });
    },
    onSubmit() {
      let url = ''
      if (this.dialogState == 'add') {
        url = '/Account/monitorCenterChannelInfo/addUser.html'
      } else if (this.dialogState == 'edit') {
        url = '/Account/monitorCenterChannelInfo/updateUser.html'
      }
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post(
            url,
            this.Qs.stringify(this.dialogForm)
          )
          if (res.code != 'success') return this.$message.error(res.message)
          this.$message.success(res.message)
          this.dialogClose()
          this.getTableList()
          console.log(res);
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.dialogForm {
  display: flex;
  flex-wrap: wrap;
}
</style>